import React from 'react'
import PrivacyPolicy from '../privacy-policy'

const PrivacyPolicyNl = () => {
    return <PrivacyPolicy languageCode="nl" />
}

export default PrivacyPolicyNl
